import { render, staticRenderFns } from "./br-table.vue?vue&type=template&id=92d026c8"
import script from "./br-table.vue?vue&type=script&lang=js"
export * from "./br-table.vue?vue&type=script&lang=js"
import style0 from "./br-table.vue?vue&type=style&index=0&id=92d026c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports